module.exports = __webpack_public_path__ + "img/zhibo_chahua.9b6a7236.png";